// Espelha o enum do backend (src/controllers/LembretesController.js).
export const REMINDER_STATUS = {
  ABERTO: 0,
  FEITO: 1,
  CONVERTIDO: 2,
  DESCARTADO: 3,
};

const LABELS = {
  [REMINDER_STATUS.ABERTO]: "Aberto",
  [REMINDER_STATUS.FEITO]: "Feito",
  [REMINDER_STATUS.CONVERTIDO]: "Virou tarefa",
  [REMINDER_STATUS.DESCARTADO]: "Descartado",
};

const CLASSES = {
  [REMINDER_STATUS.ABERTO]: "aberto",
  [REMINDER_STATUS.FEITO]: "feito",
  [REMINDER_STATUS.CONVERTIDO]: "convertido",
  [REMINDER_STATUS.DESCARTADO]: "descartado",
};

export const REMINDER_ORIGIN = {
  APP: 0,
  COMPARTILHAMENTO: 1,
  API: 2,
  ATALHO: 3,
};

// Espelha o enum de src/services/RecorrenciaService.js no backend.
export const REMINDER_RECURRENCE = {
  NENHUMA: 0,
  DIARIA: 1,
  DIAS_UTEIS: 2,
  SEMANAL: 3,
  MENSAL: 4,
};

const RECURRENCE_LABELS = {
  [REMINDER_RECURRENCE.NENHUMA]: "Nao repetir",
  [REMINDER_RECURRENCE.DIARIA]: "Todo dia",
  [REMINDER_RECURRENCE.DIAS_UTEIS]: "Dias uteis",
  [REMINDER_RECURRENCE.SEMANAL]: "Toda semana",
  [REMINDER_RECURRENCE.MENSAL]: "Todo mes",
};

export const RECURRENCE_OPTIONS = [
  REMINDER_RECURRENCE.NENHUMA,
  REMINDER_RECURRENCE.DIARIA,
  REMINDER_RECURRENCE.DIAS_UTEIS,
  REMINDER_RECURRENCE.SEMANAL,
  REMINDER_RECURRENCE.MENSAL,
];

export function getRecurrenceLabel(recorrencia) {
  return RECURRENCE_LABELS[Number(recorrencia)] || RECURRENCE_LABELS[REMINDER_RECURRENCE.NENHUMA];
}

export function ehRecorrente(recorrencia) {
  return Number(recorrencia) !== REMINDER_RECURRENCE.NENHUMA;
}

export function getReminderStatusLabel(status) {
  return LABELS[Number(status)] || "Aberto";
}

export function getReminderStatusClass(status) {
  return CLASSES[Number(status)] || "aberto";
}
